import styled from 'styled-components';

export const BaseComp = styled.div`
    display: flex;
    height: 100%;

`;

export const DivSwiper = styled.div`
    display: flex;
    flex-direction: column;

    p {
        color: var(--setra-blue);
        max-width: 200px;
    }

`;


export const TextTitle = styled.div`
    text-align: center;
    text-transform: uppercase;
    color: var(--setra-blue);


    h1 {
        font-size: 39px;
        text-transform: uppercase;
        color: var(--setra-blue);
        font-family: "Montserrat", Sans-serif;
        @media only screen and (max-width: 800px) {
            font-size: 30px;
        }
    }

    @media only screen and (max-width: 800px) {
        margin: 3% 0 2% 0 ;
    }
`;

export const TextBody = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 26px;
    text-align: left;
    padding: 10px;
    p {
        margin-top: 1%;
        color: var(--setra-blue);
        font-family: "Montserrat", Sans-serif;
    }
    @media only screen and (max-width: 800px) {
        justify-content: left;
        display: flex;
        flex-direction: column;
        align-items: left;
    }
`;

export const NewsDiv = styled.div`
`;

export const BaseContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    @media only screen and (max-width: 1000px) {
        flex-direction: column;
    }
`;

export const PrincipalDiv = styled.div`
    width: 100%;
    padding: 8%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .clientesTitle {
        position: absolute;
        top: 3%;
        text-align: center;

    }

    @media only screen and (max-width: 2000px) {
        padding: 6%;
    }
    @media only screen and (max-width: 1700px) {
        padding: 5%;
    }

    @media only screen and (max-width: 1400px) {
        padding: 4%;
    }
    @media only screen and (max-width: 1300px) {
        padding: 3%;
    }
    @media only screen and (max-width: 1100px) {
        padding:1%;
    }
    @media only screen and (max-width: 800px) {
        padding:5%;
    }
    @media only screen and (max-width: 700px) {
        padding: 10% 4%;
    }
    @media only screen and (max-width: 600px) {
        padding: 8% 3%;
    }
    /* @media only screen and (max-width: 1700px) {
        padding: 5%;
    }
    
    @media only screen and (max-width: 1100px) {
        padding: 2% 5%;
    }
    @media only screen and (max-width: 1000px) {
        padding: 3% 5%;
    } */
    /* @media only screen and (max-width: 1100px) {
        padding: 1% 3%;
    } */
    /* @media only screen and (max-width: 800px) {
        margin-top: -10%;
    }
    @media only screen and (max-width: 500px) {
        margin-top: 0%;
    } */
`;

export const CardBody = styled.div`
    background-color: white;
    height: 470px;
    @media only screen and (max-width: 1600px) {
        height: 460px
    }
    @media only screen and (max-width: 1400px) {
        height: 440px
    }
    @media only screen and (max-width: 1300px) {
        height: 380px
    }
    @media only screen and (max-width: 1200px) {
        height: 385px
    }
    @media only screen and (max-width: 900px) {
        height: 400px
    }
    @media only screen and (max-width: 600px) {
        height: 93%
    }
    /* @media only screen and (max-width: 450px) {
        height: 95%
    } */
    /* @media only screen and (max-width: 800px) {
        height: 500px
    } */
    color: var(--purple-lightdark);
`;

export const CardLogo = styled.div`
    height: 85px;
    padding-top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 800px) {
        height: 60px;
        padding-top: 2px;
    }
    img {
        max-width: 100;
        max-height: 20;
    }
`;

export const CardContent = styled.div`
    p {
        font-size: 12px;
        padding: 5px 20px;
    }
`;

export const CardName = styled.div`
    font-weight: bold;
    font-size: 14px;
`;

